export const constants = {
    WORKALIGN_ORACLE_URI_KEY: 'REACT_APP_WORKALIGN_ORACLE_URI',
    PUT_JWT_IN_QUERY_STRING_KEY: 'REACT_APP_PUT_JWT_IN_QUERY_STRING',
};

export default constants;
